// tslint:disable
/**
 * TC API
 * TestCollab is a test management tool that helps development teams carry out testing effectively and avoid failures. # Introduction This is an API documentation for TestCollab 2.   # Authentication TestCollab supports two forms of authentication:   - An <b>API token</b> is required to make API calls. The token can be generated from user's profile; to obtain it login to your TestCollab account and go to ['My Profile Settings'](https://testcollab.io/my_profile) and switch to API Token tab. Click on \"Generate new API token\", Once the token is generated it can be sent as a query parameter for the API calls made - https://api.testcollab.io/projects?token=<generated-API-token>    - <b>Bearer authentication</b> (also called token authentication) is an HTTP authentication scheme that involves security tokens called bearer tokens. You can generate bearer auth token using [Login](#operation/login) API.     Send this token as the Authorization header while making requests to protected resources:     `Authorization: Bearer <token>`    For making API calls, we recommend using the <b>API token</b> generated from user profile page as it won't affect the on-going user session and will be available until it is revoked by the user who generated it.      # Error Handling Error responses   - `Not Found` - Error is sent when requested resource is not available.   - `Unauthorized - invalid token` - Error is sent when API token sent with the request is invalid or revoked. Error contains status code 401        - `Forbidden` - Error is sent when logged in user is not part of the company, project or his role does not allow to complete given action. Response consist of 403 status code and more information is given in error message.
 *
 * OpenAPI spec version: 2.3.1
 * Contact: support@testcollab.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from "../runtime";
/**
 * Coverage data for a single requirement associated with the release.
 * @export
 * @interface ReleaseReadinessRequirementItem
 */
export interface ReleaseReadinessRequirementItem {
  /**
   *
   * @type {number}
   * @memberof ReleaseReadinessRequirementItem
   */
  requirementId: number;
  /**
   * Human-readable requirement identifier
   * @type {string}
   * @memberof ReleaseReadinessRequirementItem
   */
  requirementKey: string;
  /**
   *
   * @type {string}
   * @memberof ReleaseReadinessRequirementItem
   */
  title: string;
  /**
   * Total test cases linked to this requirement (across all projects)
   * @type {number}
   * @memberof ReleaseReadinessRequirementItem
   */
  totalLinkedCases: number;
  /**
   * Number of linked test cases that appear in this release's test plans
   * @type {number}
   * @memberof ReleaseReadinessRequirementItem
   */
  casesInRelease: number;
  /**
   * Number of cases_in_release that have been executed
   * @type {number}
   * @memberof ReleaseReadinessRequirementItem
   */
  executed: number;
  /**
   *
   * @type {number}
   * @memberof ReleaseReadinessRequirementItem
   */
  passed: number;
  /**
   *
   * @type {number}
   * @memberof ReleaseReadinessRequirementItem
   */
  failed: number;
  /**
   * fully_covered = all cases_in_release passed, partially_covered = some executed but not all passed, not_covered = none executed, no_cases = no linked test cases in the release
   * @type {string}
   * @memberof ReleaseReadinessRequirementItem
   */
  coverageStatus: ReleaseReadinessRequirementItemCoverageStatusEnum;
}

export function ReleaseReadinessRequirementItemFromJSON(
  json: any
): ReleaseReadinessRequirementItem {
  return {
    requirementId: json["requirement_id"],
    requirementKey: json["requirement_key"],
    title: json["title"],
    totalLinkedCases: json["total_linked_cases"],
    casesInRelease: json["cases_in_release"],
    executed: json["executed"],
    passed: json["passed"],
    failed: json["failed"],
    coverageStatus: json["coverage_status"],
  };
}

export function ReleaseReadinessRequirementItemToJSON(
  value?: ReleaseReadinessRequirementItem
): any {
  if (value === undefined) {
    return undefined;
  }
  return {
    requirement_id: value.requirementId,
    requirement_key: value.requirementKey,
    title: value.title,
    total_linked_cases: value.totalLinkedCases,
    cases_in_release: value.casesInRelease,
    executed: value.executed,
    passed: value.passed,
    failed: value.failed,
    coverage_status: value.coverageStatus,
  };
}

/**
 * @export
 * @enum {string}
 */
export enum ReleaseReadinessRequirementItemCoverageStatusEnum {
  FullyCovered = "fully_covered",
  PartiallyCovered = "partially_covered",
  NotCovered = "not_covered",
  NoCases = "no_cases",
}
